// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__13VU5","LogoBaseline":"Logo_LogoBaseline__Obxzk","LogoSize":"Logo_LogoSize__2t_bH"};